module.exports = __webpack_public_path__ + "static/img/hoverlogo08.b4803938.png";